
export default function Privacy() {
  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-4xl font-bold mb-4 sm:mb-6 text-gray-800">
          プライバシーポリシー
        </h2>
        <div className="space-y-3 sm:space-y-4">
          <h3 className="text-base sm:text-xl font-bold text-gray-800">
            データの収集、利用、共有
          </h3>
          <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
            当サイトで収集された情報を管理保護するのは、個人事業主である当方のみです。当方が収集する個人情報は当サイトの閲覧者が自発的に提供したもののみで、状況説明とその後の同意なくして個人情報を第三者に譲渡しません。
          </p>
        </div>

        <footer className="mt-12 sm:mt-20 pt-6 sm:pt-8 border-t border-gray-200">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/0f43beb23aaca34fe525f322afdb3a4e/91f45852d6469a87479e767848617524.jpeg"
                  alt="Refresh Labo ロゴ"
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-xs sm:text-sm text-gray-600">
                ©2020 by refresh labo
              </p>
            </div>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs sm:text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </footer>
      </div>
    </section>
  );
}
